export const isAppStoreSubscription = (subscriptionService) =>
  subscriptionService === 'app-store'
